import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

import { ErrorStylesProps } from '../../types/interface/styles.interface'

export const useCtaStyles = makeStyles<ErrorStylesProps>()((theme: Theme, props) => ({
  footer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 'auto',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-end',
    },
    '& > a': {
      textDecoration: 'none',
      color: theme.brand.colors.secondary,
      '&:hover': {
        textDecoration: props && props.externalLink ? 'underline' : 'none',
      },
    },
    ...theme.brand.assets.layout?.StylesCommonCtaFooter,
  },

  link: {
    fontWeight: 'bold',
    fontSize: '1rem',
  },

  disclaimer: {
    textAlign: 'center',
    color: theme.brand.colors.textSecondary,
    marginBottom: theme.spacing(2.5),
    ...theme.brand.assets.layout?.PolicyCTAOverride,
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(1),
    },
  },
}))
